import { createContext, useContext } from "react";
import { getClientConfig } from "../config/clientes";

const clientId = process.env.REACT_APP_CLIENT_ID || "ariel";
export const clientConfig = getClientConfig(clientId);

export const ClientContext = createContext(clientConfig);
export const useClient = () => useContext(ClientContext);

/** En autoadministrado el profesional tiene las mismas capacidades que un admin de clínica. */
export function canManageClinica(user, multiProfesional) {
  if (!user) return false;
  if (multiProfesional) return user.role === "admin";
  return user.role === "profesional" || user.role === "admin";
}

export function ClientProvider({ children }) {
  return (
    <ClientContext.Provider value={clientConfig}>
      {children}
    </ClientContext.Provider>
  );
}
